import { trackClientEvent } from '../../../../../trackClientEvent';
export const eventKey = 'signup-open_product_sign_up_modal-click';
/**
 * Logged out user clicks on a product tile and sees the product version of the sign up modal
 */
export function trackSignupOpenProductSignUpModalClick(productToken) {
    return trackClientEvent({
        eventKey,
        realTimeTracking: false,
        parameters: { productToken },
    });
}
